import React from 'react';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import Paragraph from '../../Typography/Paragraph';
import * as styles from './style.module.css';
const Content = ({ className, ...commonProps }) => {
    const classes = clsx(styles.content, className);
    return Depot.createElement('div', { ...commonProps, className: classes });
};
const Header = (commonProps) => (React.createElement(Paragraph, { typeStyle: "small", as: "p", color: "base", fontWeight: "bold", ...commonProps }));
const Body = (commonProps) => (React.createElement(Paragraph, { typeStyle: "small", as: "p", color: "subtle", fontWeight: "regular", ...commonProps }));
const SideItem = ({ className, ...commonProps }) => {
    const classes = clsx(styles.sideItem, className);
    return Depot.createElement('div', { ...commonProps, className: classes });
};
export var MessageMood;
(function (MessageMood) {
    MessageMood["PRIMARY"] = "primary";
    MessageMood["SECONDARY"] = "secondary";
    MessageMood["NEUTRAL"] = "neutral";
    MessageMood["INFO"] = "info";
    MessageMood["POSITIVE"] = "positive";
    MessageMood["WARNING"] = "warning";
    MessageMood["NEGATIVE"] = "negative";
})(MessageMood || (MessageMood = {}));
const Message = ({ className, mood, href, ...commonProps }) => {
    const classes = clsx(styles.root, styles[mood], href && styles.link, className);
    return Depot.createElement(href ? 'a' : 'div', {
        ...commonProps,
        className: classes,
        ...(href && {
            href,
            target: '_blank',
            rel: 'noreferrer',
        }),
    });
};
Message.Content = Content;
Message.Header = Header;
Message.Body = Body;
Message.LeadingItem = SideItem;
Message.TrailingItem = SideItem;
export default Message;
//# sourceMappingURL=index.js.map